/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wrapped_CloseInputs */

const en_us2_wrapped_close = /** @type {(inputs: Wrapped_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close retrospective`)
};

const pt_br2_wrapped_close = /** @type {(inputs: Wrapped_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar retrospectiva`)
};

const es_419_wrapped_close = /** @type {(inputs: Wrapped_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar resumen`)
};

const pt_pt2_wrapped_close = /** @type {(inputs: Wrapped_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar retrospetiva`)
};

const fr_fr2_wrapped_close = /** @type {(inputs: Wrapped_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer le bilan`)
};

const de_de2_wrapped_close = /** @type {(inputs: Wrapped_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rückblick schließen`)
};

const it_it2_wrapped_close = /** @type {(inputs: Wrapped_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiudi il riepilogo`)
};

/**
* | output |
* | --- |
* | "Close retrospective" |
*
* @param {Wrapped_CloseInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_close = /** @type {((inputs?: Wrapped_CloseInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_CloseInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_close(inputs)
	if (locale === "es-419") return es_419_wrapped_close(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_close(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_close(inputs)
	if (locale === "de-DE") return de_de2_wrapped_close(inputs)
	if (locale === "it-IT") return it_it2_wrapped_close(inputs)
	return en_us2_wrapped_close(inputs)
});
export { wrapped_close as "wrapped.close" }